"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  root: ({
    theme
  }) => ({
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 'bold'
  })
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiAlertTitle.js.map